<template>
  <div id="bsModalBuy" aria-labelledby="bsModalBuyLabel" class="modal fade" data-backdrop="static"
       data-keyboard="false" data-toggle="modal"
       role="dialog" tabindex="-1" @click="clickOverlay()">
    <div class="modal-dialog" role="document" @click.stop>
      <div class="modal-content">
        <div class="modal-header">
          <button aria-label="Close" class="close" type="button" @click="close()">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 id="bsModalBuyLabel" class="modal-title">{{ title }}</h4>
        </div>
        <div class="modal-body">
          <template v-if="transaction === ''">
            <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
              <form @submit.prevent="handleSubmit(onSubmit)">
                <ValidationProvider v-slot="{ errors }" class="form-group" name="input currency" rules="required"
                                    tag="div">
                  <label for="crypto-deposit-inputCurrency">Input Currency</label>
                  <select id="crypto-deposit-inputCurrency" v-model="form.inputCurrency" class="form-control">
                    <option v-for="(inputCurrency, index) in inputCurrencies" :key="index"
                            :value="inputCurrency.ShortName">
                      {{ inputCurrency.Name + ' - ' + inputCurrency.LongName }}
                    </option>
                  </select>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
                <ValidationProvider v-slot="{ errors }" class="form-group" name="amount" :rules="{
                    required: true,
                    regex:/^\d*\.?\d{1,8}$/
                  }" tag="div">
                  <label for="crypto-deposit-amount">Amount</label>
                  <input id="crypto-deposit-amount" v-model="form.Amount" @keyup="trimValue('Amount')"
                         class="form-control" type="text"/>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
                <ValidationProvider v-slot="{ errors }" class="form-group" name="merchant id" rules="required"
                                    tag="div">
                  <label for="crypto-deposit-merchantID">Merchant</label>
                  <input type="text" id="crypto-deposit-merchantID" v-model="form.MerchantID" readonly
                         class="form-control">
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
                <ValidationProvider v-slot="{ errors }" class="form-group" name="api key" rules="required" tag="div">
                  <label for="crypto-deposit-apiKey">API Key</label>
                  <input id="crypto-deposit-apiKey" v-model="form.APIKey" class="form-control" readonly type="text"/>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
                <ValidationProvider v-slot="{ errors }" class="form-group" name="altCoinID" rules="required" tag="div">
                  <label for="crypto-deposit-altCoinID">AltCoinID</label>
                  <input type="text" id="crypto-deposit-altCoinID" v-model="form.AltCoinID" readonly
                         class="form-control"/>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
                <div class="text-right">
                  <button :disabled="isLoading" class="btn btn-primary btn-flat" type="submit">
                    <span v-if="!isLoading">Buy</span>
                    <span v-if="isLoading"><i class="fa fa-circle-o-notch fa-spin"></i></span>
                  </button>
                </div>
              </form>
            </ValidationObserver>
          </template>
          <template v-else>
            <div v-html="transaction"></div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { saveNotification } from '@/lib/utils'

export default {
  name: 'BuyModal',
  data() {
    return {
      isLoading: false,
      title: '',
      transaction: '',
      inputCurrencies: [],
      data: null,
      form: {
        Call: 'CreateTransaction',
        MerchantID: '',
        APIKey: '',
        AltCoinID: '',
        inputCurrency: '',
        Amount: '',
        V2: true,
        output: 'json'
      },
      confirmHook: () => {
      }
    }
  },
  computed: {
    ...mapGetters([
      'jwtToken',
      'onlineAltCoins'
    ])
  },
  methods: {
    trimValue(key) {
      this.form[key] = this.form[key] ? this.form[key].trim() : ''
    },
    confirm() {
      this.confirmHook()
      this.close()
    },
    onSubmit() {
      this.isLoading = true
      const payload = JSON.parse(JSON.stringify(this.form))
      const apiBaseUrl = process.env.VUE_APP_API_URL
      this.$http.get(`${apiBaseUrl}/v2REAPI`, {
        params: payload
      }).then(response => {
        this.isLoading = false
        const result = response.data
        if (result.status_code === 400) {
          this.$toast.fire('', result.message, 'error')
        }
        if (result.result.toLowerCase() === 'success') {
          this.reset()
          setTimeout(() => {
            this.transaction = result.message
          }, 100)
          this.$toast.fire('', 'Transaction created successfully', 'success')
          saveNotification('Transaction created successfully')
        }
      }).catch(error => {
        this.isLoading = false
        console.log(error)
      })
    },
    clickOverlay() {
      // Hide modal
      this.close()
    },
    reset() {
      this.form = {
        Call: 'CreateTransaction',
        MerchantID: '',
        APIKey: '',
        AltCoinID: '',
        inputCurrency: '',
        Amount: '',
        V2: '',
        output: 'json'
      }
      this.$nextTick(() => this.$refs.observer.reset())
    },
    close() {
      if (this.transaction === '') {
        this.reset()
      }
      this.transaction = ''
      $('#bsModalBuy').modal('hide')
    }
  },
  mounted() {
    this.inputCurrencies = this.onlineAltCoins
    this.$bus.$on('buy-modal', (args) => {
      this.title = args.title
      this.data = args.data
      // Populate form
      this.form = {
        ...this.form,
        MerchantID: this.data.MerchantID,
        APIKey: this.data.APIKey,
        AltCoinID: this.data.ID
      }
      this.confirmHook = args.confirm
      $('#bsModalBuy').modal('show')
    })
  }
}
</script>

<style scoped></style>
